import { Component, inject, input } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { StaticContentService } from '../../../services/static-content.service';
import { GameProvider, GameProvidersService } from '../../../services/game-providers.service';
import { BankingService } from '../../../services/banking.service';
import { ScriptLoaderService } from '../../../services/script-loader.service';
import { UserService } from '../../../services/user/user.service';
import { filter, first, map } from 'rxjs/operators';
import { StaticContentType } from '../../../../../environments/environment';
import { GoogleTagManagerService } from '../../../services/google-tag-manager.service';
import { PlatformService } from '../../../services/platform.service';
import { HttpStatus } from '../../../services/response-handler.service';
import { OffersService } from '../../../services/offers.service';
import { TranslatePipe } from '../../translation/translate.pipe';
import { SafePipe } from '../../pipes/safe.pipe';
import { RouterLinkDirective } from '../../directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { ImgDimensionDirective } from '../../directives/img-dimension.directive';
import { DeleteNotFoundDirective } from '../../directives/delete-not-found.directive';
import { ClassLoadedDirective } from '../../directives/class-loaded.directive';
import { SetImgAltDirective } from '../../directives/set-img-alt.directive';
import { AccordionButtonComponent } from '../../components/accordion-button/accordion-button.component';
import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { AppShellNoSSRDirective, AppShellRenderSSRDirective } from 'ngx-unificator/directives';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [AccordionButtonComponent, AppShellNoSSRDirective, AppShellRenderSSRDirective, NgTemplateOutlet, SetImgAltDirective, ClassLoadedDirective, DeleteNotFoundDirective, ImgDimensionDirective, RouterLink, RouterLinkDirective, NgClass, AsyncPipe, SafePipe, TranslatePipe]
})
export class FooterComponent {
  user = inject(UserService);
  banking = inject(BankingService);
  private _staticContent = inject(StaticContentService);
  private _gameProviders = inject(GameProvidersService);
  private _scriptLoader = inject(ScriptLoaderService);
  private _gtm = inject(GoogleTagManagerService);
  private _platform = inject(PlatformService);
  private _offer = inject(OffersService);

  /**
   * Pass true if you want hide license text and logos
   */
  readonly hideText = input<boolean>(undefined);

  /**
   * Copyright text from CMS
   */
  public copyright$: ReplaySubject<any> = this._staticContent.item({slug: 'footer-copyright'});

  public license$: Observable<{Img: string; Url: string;}> = this._staticContent.item({ slug: 'ss-license-static' }).pipe(
    filter(data => !!data?.[0]),
    first(),
    map(data => data?.[0]),
  );

  /**
   * Social Footer content from CMS
   */
  public social$ = this._offer.item({slug: 'ss-social-promo'})
    .pipe(filter(response => response &&
      response[0].statusCode !== HttpStatus.MOVED_PERMANENTLY &&
      response[0].statusCode !== HttpStatus.NOT_FOUND),
    );

  /**
   * Partners from CMS
   */
  public partnerList$: ReplaySubject<[{Link: string; Text: string; Logo: string}]> = this._staticContent.list(
    {type: StaticContentType.PARTNERS});

  /**
   * List of game providers
   */
  public providerList$: ReplaySubject<GameProvider[]> = this._gameProviders.list$.pipe(
    map(list => list.filter(e => e.inFooter)),
  ) as ReplaySubject<GameProvider[]>;

  constructor() {
    if (this._platform.isBrowser) {
      this._scriptLoader.load('https://images.dmca.com/Badges/DMCABadgeHelper.min.js').subscribe();
    }
  }

  onProviderClick(provider) {
    this._gtm.depositVendorClick(
      'deposit_click_vendor',
      provider.slug ? provider.slug : provider.alias,
      provider.slug ? provider.slug : provider.alias,
      this.user.info.id
    );
  }
}

